import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import SaleFooter from '../SaleFooter/SaleFooter';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../../provider/providerManager';
import { getRecaptchaToken } from '../../../../utilities/recaptcha/recaptcha';
import { cgTypeEnum } from '../../../../utilities/enums/cgTypeEnum';
import {
  goToPage,
  reportAnalytics,
  setIsSubmit,
  setIsValid,
  setError,
  setPayment,
  setBan,
  setNvIipSeq,
  setTransactionId,
} from '../saleBlockSlice';
import { setPhoneListData } from '../../EsimGeneralBlock/esimBlockSlice';
import PaymentCG from '../PaymentCG/PaymentCG';
import Config from '../../../../Config';

const PaymentPage = (props) => {
  let saleType = props.saleType;

  useEffect(() => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    switch (saleType) {
      case 'tv':
        props.reportAnalytics({ eventCategory: 'tv_newsale_process', eventAction: 'visibility_24', eventLabel: eventLabel });
        break;
      case 'app':
        props.reportAnalytics({ eventCategory: 'app_newsale_process', eventAction: 'visibility_32', eventLabel: eventLabel });
        break;
      case 'cellular':
        props.reportAnalytics({ eventCategory: 'cellular_newsale_process', eventAction: 'visibility_27', eventLabel: 'screen_17' });
        break;
      case 'internet':
        props.reportAnalytics({ eventCategory: 'fiber_newsale_process', eventAction: 'visibility_21', eventLabel: eventLabel });
        break;
    }
  }, []);

  //page params
  let isDisplayFooter = true;
  let btnText = 'אישור תשלום';
  let currentPageFunction = handlePaymentPageContinue;
  let totalPrice = null;
  let priceText = 'לחודש';
  let formid = 'sale';
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'> השלמת הזמנה </h1>
    </div>
  );
  let currentPageView;

  currentPageView = (
    <PaymentCG
      isShowIdNumber={true}
      isShowTerms={true}
      type={cgTypeEnum.CHECKCARD}
      onValid={handlePaymentValidate}
      onSubmit={props.isSubmit}
      isValid={props.isValid}
      onError={handleOnError}
      customerId={props.personalInfo.id}
      selectedProducts={props.productsInfo.selectedProducts}
      source="SaleBlock"
    />
  );

  function handlePaymentPageContinue() {
    props.setIsSubmit({ isSubmit: true });
  }

  function handlePaymentValidate(valid) {
    props.setIsSubmit({ isSubmit: false });
    if (valid) {
      handlePaymentPageContinueAfterValid();
    }
    props.setIsSubmit({ isSubmit: false });
  }

  function handleOnError(errorId) {
    props.setError({ isDisplay: true, id: errorId, isOpenWorkOrder: true });
  }

  async function handlePaymentPageContinueAfterValid() {
    let payment = {};

    var credit4Digits = props._paymentCg.Credit4Digits.slice(props._paymentCg.Credit4Digits.length - 4);

    payment = {
      userName: '',
      id: props._paymentCg.form.id,
      cardNumber: '',
      terminalNumber: cgTypeEnum.CHECKCARD,
      authNumber: props._paymentCg.form.confirmationNumber,
      cardDueYear: props._paymentCg.form.CardDueYear,
      cardDueMonth: props._paymentCg.form.CardDueMonth,
      cvv: '',
      cCToken: props._paymentCg.CCToken,
      cCType: props._paymentCg.CCType,
      credit4Digits: credit4Digits,
    };

    props.setPayment({ payment: payment });

    let eventLabel = props.productsInfo.selectedProducts[0]?.name;

    switch (saleType) {
      case 'tv':
        props.reportAnalytics({ eventCategory: 'tv_newsale_process', eventAction: 'click_34', eventLabel: eventLabel });
        break;
      case 'app':
        props.reportAnalytics({ eventCategory: 'app_newsale_process', eventAction: 'click_44', eventLabel: eventLabel });
        break;
      case 'cellular':
        props.reportAnalytics({ eventCategory: 'cellular_newsale_process', eventAction: 'click_50', eventLabel: 'button_15' });
        break;
      case 'internet':
        props.reportAnalytics({ eventCategory: 'fiber_newsale_process', eventAction: 'click_27', eventLabel: eventLabel });
        break;
    }

    // if (!props.isCustomerExposureSuccess) {
    //   console.info('isCustomerExposureSuccess', props.isCustomerExposureSuccess);
    //   props.setError({ isDisplay: true, id: 1, isOpenWorkOrder: true });
    //   return;
    // }

    let nvIipSeq = '';

    const isCreditCardValidationSuccess = await creditCardValidation(payment);


    if (!isCreditCardValidationSuccess) {
      return;
    }

    const ban = await createCustomer(payment);

    const isCreateCustomerSuccess = ban != '';
    if (!isCreateCustomerSuccess) {
      props.setError({ isDisplay: true, id: 11 });
      return;
    }

    if (saleType == 'internet') {
      let internalRequestId = '';

      //---------- createFiberSequence ----------
      nvIipSeq = await createFiberSequence(ban);
      props.setNvIipSeq(nvIipSeq);
      const isCreateFiberSequence = nvIipSeq != '';
      if (!isCreateFiberSequence) {
        props.setError({ isDisplay: true, id: 39 });
        return;
      }
      //---------- createFiberSequence ----------

      if (props.selectedAddress.infrastructure.tashtitType == 'FIBER' || props.selectedAddress.infrastructure.tashtitType == 'IBC') {
        //-------------- preSaleCheck --------------
        const cityCode = props.selectedAddress.city;
        const cityName = props.selectedAddress.cityName;
        const streetCode = props.selectedAddress.street;
        const streetName = props.selectedAddress.streetName;
        const houseNum = props.selectedAddress.home;
        const apartment = props.selectedAddress.apartment;
        const letter = props.selectedAddress.enter;

        internalRequestId = await preSaleCheck(ban, nvIipSeq, cityCode, cityName, streetCode, streetName, houseNum, apartment, letter);
        const isPreSaleCheckSuccess = internalRequestId != '';
        if (!isPreSaleCheckSuccess) {
          props.setError({ isDisplay: true, id: 37 });
          return;
        }
        //-------------- preSaleCheck --------------

        //------------ createFiberOrder ------------
        const bodyTo = props.selectedAddress.infrastructure.tashtitType == 'IBC' ? 'BC' : 'FB';
        const firstName = props.personalInfo.firstName;
        const lastName = props.personalInfo.lastName;
        const identity = props.personalInfo.id;
        const contactPhoneNumber = props.otpPhone;
        const contactName2 = '';

        const isCreateFiberOrderSuccess = await createFiberOrder(
          bodyTo,
          ban,
          nvIipSeq,
          internalRequestId,
          lastName,
          firstName,
          identity,
          contactPhoneNumber,
          contactName2
        );
        if (!isCreateFiberOrderSuccess) {
          props.setError({ isDisplay: true, id: 41 });
          return;
        }
        //------------ createFiberOrder ------------
      }
    }

    const isMakeSaleSuccess = await makeSale(ban, payment, nvIipSeq);
    if (!isMakeSaleSuccess) {
      return;
    }

    props.goToPage({ page: 'successPage', percent: 100 });
  }

  //1434
  async function creditCardValidation(payment) {
    props.showAppLoader();
    try {
      console.info('creditCardValidation:', 'creditCardType:' + payment.cCType + ' cCToken:' + payment.cCToken + ' idNumber:', payment.id);

      const result = await ProviderManager.getProviderData('creditCardValidation', [payment.cCType, payment.cCToken, payment.id]);
      console.info('creditCardValidation', result);

      const isSuccess = result.Body.isSuccess;
      return isSuccess;
    } catch (error) {
      console.info(error);
      props.setError({ isDisplay: true, id: error.errorCode, isOpenWorkOrder: true });
      return false;
    } finally {
      props.hideAppLoader();
    }
  }

  //448
  async function createFiberSequence(ban) {
    props.showAppLoader();
    try {
      const fiberSequence = {
        personId: ban,
        nvIdType: 'BAN',
      };
      console.info('createFiberSequence', JSON.stringify(fiberSequence));
      const result = await ProviderManager.getProviderData('createFiberSequence', fiberSequence);
      console.info('createFiberSequence', result);

      const isSuccess = result.Body.isSuccess;
      if (isSuccess) {
        return result.Body.nvIipSeq;
      }
      return '';
    } catch (error) {
      console.info(error);
      props.setError({ isDisplay: true, id: 38 });
      return '';
    } finally {
      props.hideAppLoader();
    }
  }

  //750//1421
  async function preSaleCheck(ban, nvIipSeq, cityCode, cityName, streetCode, streetName, houseNum, apartment, letter) {
    const captchaToken = await getRecaptchaToken('preSaleCheck');
    if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
      return;
    }

    props.showAppLoader();
    try {
      const preSale = {
        ban: ban,
        nvIipSeq: nvIipSeq,
        cityCode: cityCode,
        cityName: cityName,
        streetCode: streetCode,
        streetName: streetName,
        houseNum: houseNum,
        apartment: apartment,
        capchaValue: captchaToken,
        letter: letter,
      };
      console.info('preSaleCheck', JSON.stringify(preSale));
      const result = await ProviderManager.getProviderData('preSaleCheck', preSale);
      console.info('preSaleCheck', result);

      const isSuccess = result.Body.isSuccess;
      const internalRequestId = isSuccess ? result.Body.internalRequestId : '';
      return internalRequestId;
    } catch (error) {
      console.info(error);
      props.setError({ isDisplay: true, id: 38 });
      return '';
    } finally {
      props.hideAppLoader();
    }
  }

  //750//1420
  async function createFiberOrder(bodyTo, ban, seq, internalRequestId, lastName, firstName, identity, contactPhoneNumber, contactName2) {
    props.showAppLoader();
    try {
      const fiberOrder = {
        BodyTo: bodyTo,
        Ban: ban,
        Seq: seq,
        InternalRequestId: internalRequestId,
        LastName: lastName,
        FirstName: firstName,
        Identity: identity,
        ContactPhoneNumber: contactPhoneNumber,
        ContactName2: contactName2,
      };
      console.info('createFiberOrder', JSON.stringify(fiberOrder));
      const result = await ProviderManager.getProviderData('createFiberOrder', fiberOrder);
      console.info('createFiberOrder', result);

      const isSuccess = result.Body.isSuccess;
      return isSuccess;
    } catch (error) {
      console.info(error);
      props.setError({ isDisplay: true, id: 40 });
      return false;
    } finally {
      props.hideAppLoader();
    }
  }

  /*
  //750//1483
  async function lockIBCTechnician(internalRequestId, estimatedTimeFrom, estimatedTimeTo, calendarId) {
    props.showAppLoader();
    try {
      const ibcTechnician = {
        internalRequestId: internalRequestId,
        estimatedTimeFrom: estimatedTimeFrom,
        estimatedTimeTo: estimatedTimeTo,
        calendarId: calendarId,
      };
      console.info('lockIBCTechnician', JSON.stringify(ibcTechnician));
      const result = await ProviderManager.getProviderData('lockIBCTechnician', ibcTechnician);
      console.info('lockIBCTechnician', result);

      const isSuccess = result.Body.isSuccess;
      if (!isSuccess) {
        props.setError({isDisplay: true, id: result.Body.codeError, isOpenWorkOrder: true});
      }
      return isSuccess;
    } catch (error) {
      console.info(error);
      props.setError({isDisplay: true, id: 44, isOpenWorkOrder: true});
      return false;
    } finally {
      props.hideAppLoader();
    }
  }
  */

  /*
  //1750
  async function ibcUpdateOrderData(internalRequestId, ibcCustExists) {
    props.showAppLoader();
    try {
      console.info('ibcUpdateOrderData', 'internalRequestId=' + internalRequestId + ' ibcCustExists=' + ibcCustExists);
      const result = await ProviderManager.getProviderData('ibcUpdateOrderData', [internalRequestId, ibcCustExists]);
      console.info('ibcUpdateOrderData', result);

      const isSuccess = result.Body.isSuccess;
      return isSuccess;
    } catch (error) {
      console.info(error);
      props.setError({isDisplay: true, id: 36});
      return false;
    } finally {
      props.hideAppLoader();
    }
  }
  */

  //1443
  async function createCustomer(payment) {
    const captchaToken = await getRecaptchaToken('createCustomer');
    if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
      return;
    }

    props.showAppLoader();
    try {
      const saleWizard = {
        token: captchaToken,
        saleType: props.saleType,
        selectedAddress: props.selectedAddress,
        personalInfo: props.personalInfo,
        otpPhone: props.otpPhone,
        otpCode: props.otpCode,
        payment: payment,
        phoneForDelivery: props.phoneForDelivery,
        isFamilyPackage: props.isFamilyPackage
      };
      console.info('createCustomer', JSON.stringify(saleWizard));
      const result = await ProviderManager.getProviderData('Ban', saleWizard);
      console.info('createCustomer', result);

      const isSuccess = result.Body.returnCode == '00';
      if (isSuccess) {
        props.setBan({ ban: result.Body.ban });
        return result.Body.ban;
      }
      return '';
    } catch (error) {
      console.info(error);
      return '';
    } finally {
      props.hideAppLoader();
    }
  }

  //1716
  async function makeSale(ban, payment, nvIipSeq) {
    const captchaToken = await getRecaptchaToken('makeSale');
    if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
      return;
    }

    props.showAppLoader();
    try {
      const personalInfo = {
        firstName: props.personalInfo.firstName,
        lastName: props.personalInfo.lastName,
        id: props.personalInfo.id,
        email: props.personalInfo.email,
        isReceivingAd: props.personalInfo.isReceivingAd,
        isReceivingBill: props.personalInfo.isReceivingBill,
        ban: ban,
      };

      const vasList = [];
      props.premiumPackages.forEach(function (item) {
        if (item.isSelected) {
          item.vasList.forEach(function (vas) {
            if (vas.isSelected) {
              vasList.push(vas.id);
            }
          });
        }
      });

      const saleWizard = {
        token: captchaToken,
        blockId: props.blockId,
        saleType: props.saleType,
        flowType: props.flowType,
        offerId: props.offerInfo.offerId,
        products: props.productsInfo.selectedProducts,
        vasList: vasList,
        selectedAddress: props.selectedAddress,
        personalInfo: personalInfo,
        accountInfo: props.accountInfo,
        otpPhone: props.otpPhone,
        otpCode: props.otpCode,
        otpTicketId: props.otpTicketId,
        payment: payment,
        phoneForDelivery: props.phoneForDelivery,
        supplyType: props.supplyType,
        setupDeliveries: props.setupDeliveries,
        technicianArrivalTimeIbc: props.technicianArrivalTimeIbc,
        technicianArrivalTime: props.technicianArrivalTime,
        deliveryCost: props.deliveryCost,
        totalPrice: props.totalPrice,
        isMeshUpgrade: props.isMeshUpgrade,
        nvIipSeq: nvIipSeq,
        isProductUpgraded: props.isProductUpgraded,
        isSkipToNewCustomer: props.isSkipToNewCustomer,
        isFamilyPackage: props.isFamilyPackage
      };

      console.info('makeSale', JSON.stringify(saleWizard));
      const result = await ProviderManager.getProviderData('makeSale', saleWizard);
      console.info('makeSale', result);
      const isSuccess = result.Header.ReturnCode == 0 && result.Body.isSuccess;
      const isEsimSuccess = result?.Body?.isSuccess && result?.Body?.extra?.success == true;
      if (!isSuccess) {
        if (result.Body.codeError == '94') {
          props.setError({ isDisplay: true, id: 13, isOpenWorkOrder: true });
        } else {
          makeSaleShowError(result.Header.ReturnCode);
        }
      }

      if (isEsimSuccess) {
        props.setPhoneListData(result?.Body?.extra?.data);
      }

      props.setTransactionId(result.Body.resultMessage);
      return isSuccess;
    } catch (error) {
      console.info('makeSale', error);
      makeSaleShowError(error.errorCode);

      return false;
    } finally {
      props.hideAppLoader();
    }
  }

  function makeSaleShowError(errorCode) {
    switch (errorCode) {
      case 57:
      case 58:
      case 59:
      case 60:
        props.setError({ isDisplay: true, id: errorCode, isOpenWorkOrder: true });
        break;
      default:
        props.setError({ isDisplay: true, id: 14, isOpenWorkOrder: true });
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}

      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {' '}
          {currentPageView}{' '}
        </form>

        {props._paymentCg.form.confirmationNumber ? (
          <SaleFooter
            isDisplayFooter={isDisplayFooter}
            btnText={btnText}
            onclick={currentPageFunction}
            price={totalPrice}
            priceText={priceText}
            formid={formid}
          />
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    configuration: state.saleBlock.epiServer.configuration,
    totalPrice: state.saleBlock.totalPrice,
    isSubmit: state.saleBlock.isSubmit,
    isValid: state.saleBlock.isValid,
    blockId: state.saleBlock.epiServer.blockId,
    productsInfo: state.saleBlock.productsInfo,
    offerInfo: state.saleBlock.epiServer.offerInfo,
    premiumPackages: state.saleBlock.premiumPackages,
    selectedAddress: state.saleBlock.selectedAddress,
    personalInfo: state.saleBlock.personalInfo,
    accountInfo: state.saleBlock.accountInfo,
    customerEmail: state.saleBlock.customerEmail,
    otpPhone: state.saleBlock.otpPhone,
    otpCode: state.saleBlock.otpCode,
    otpTicketId: state.saleBlock.otpTicketId,
    phoneForDelivery: state.saleBlock.phoneForDelivery,
    supplyType: state.saleBlock.supplyType,
    setupDeliveries: state.saleBlock.setupDeliveries,
    technicianArrivalTimeIbc: state.saleBlock.technicianArrivalTimeIbc,
    technicianArrivalTime: state.saleBlock.technicianArrivalTime,
    deliveryCost: state.saleBlock.deliveryCost,
    isCustomerExposureSuccess: state.saleBlock.isCustomerExposureSuccess,
    chooseNumber: state.saleBlock.chooseNumber,
    isMeshUpgrade: state.saleBlock.isMeshUpgrade,
    isCustomerConnectedToIbc: state.saleBlock.isCustomerConnectedToIbc,
    isProductUpgraded: state.saleBlock.isProductUpgraded,
    isSkipToNewCustomer: state.saleBlock.isSkipToNewCustomer,
    isFamilyPackage: state.saleBlock.isFamilyPackage,
    //other states

    _paymentCg: state.PaymentCG,
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  setIsSubmit,
  setIsValid,
  setError,
  setPayment,
  setBan,
  setNvIipSeq,
  setTransactionId,
  setPhoneListData,

  //loader
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPage);
